import {NICEAgent} from './NICE_Agent.model';

export class NICETeamAgent {
    teamId: number;
    teamName: string;
    isActive: boolean;
    description: string;
    notes: string;
    lastUpdateTime: string;
    inViewEnabled: boolean;
    wfoEnabled: boolean;
    wfm2Enabled: boolean;
    qm2Enabled: boolean;
    maxConcurrentChats: number;
    agentCount: number;
    maxEmailAutoParkingLimit: number;
    inViewGamificationEnabled: boolean;
    inViewChatEnabled: boolean;
    inViewLMSEnabled: boolean;
    analyticsEnabled: boolean;
    requestContact: boolean;
    contactAutoFocus: boolean;
    chatThreshold: number;
    emailThreshold: number;
    workItemThreshold: number;
    voiceThreshold: number;
    evolveTeamId: string;
    teamLeadUuid: string;
    niceAudioRecordingEnabled: boolean;
    niceDesktopAnalyticsEnabled: boolean;
    niceQmEnabled: boolean;
    niceScreenRecordingEnabled: boolean;
    niceSpeechAnalyticsEnabled: boolean;
    niceWfmEnabled: boolean;
    niceQualityOptimizationEnabled: boolean;
    niceSurveyCustomerEnabled: boolean;
    nicePerformanceManagementEnabled: boolean;
    niceAnalyticsEnabled: boolean;
    niceLessonManagementEnabled: boolean;
    niceCoachingEnabled: boolean;
    niceStrategicPlannerEnabled: boolean;
    niceShiftBiddingEnabled: boolean;
    niceWfoAdvancedEnabled: boolean;
    niceWfoEssentialsEnabled: boolean;
    agents: NICEAgent[];

    constructor(niceTeam?) {
        if (niceTeam) {
            this.teamId = niceTeam.teamId || 0;
            this.teamName = niceTeam.teamName || '';
            this.isActive = niceTeam.isActive === true;
            this.description = niceTeam.description || '';
            this.notes = niceTeam.notes || '';
            this.lastUpdateTime = niceTeam.lastUpdateTime || '';
            this.inViewEnabled = niceTeam.inViewEnabled === true;
            this.wfoEnabled = niceTeam.wfoEnabled === true;
            this.wfm2Enabled = niceTeam.wfm2Enabled === true;
            this.qm2Enabled = niceTeam.qm2Enabled === true;
            this.maxConcurrentChats = niceTeam.maxConcurrentChats || 0;
            this.agentCount = niceTeam.agentCount || 0;
            this.maxEmailAutoParkingLimit = niceTeam.maxEmailAutoParkingLimit || 0;
            this.inViewGamificationEnabled = niceTeam.inViewGamificationEnabled === true;
            this.inViewChatEnabled = niceTeam.inViewChatEnabled === true;
            this.inViewLMSEnabled = niceTeam.inViewLMSEnabled === true;
            this.analyticsEnabled = niceTeam.analyticsEnabled === true;
            this.requestContact = niceTeam.requestContact === true;
            this.contactAutoFocus = niceTeam.contactAutoFocus === true;
            this.chatThreshold = niceTeam.chatThreshold || 0;
            this.emailThreshold = niceTeam.emailThreshold || 0;
            this.workItemThreshold = niceTeam.workItemThreshold || 0;
            this.voiceThreshold = niceTeam.voiceThreshold || 0;
            this.evolveTeamId = niceTeam.evolveTeamId || '';
            this.teamLeadUuid = niceTeam.teamLeadUuid || '';
            this.niceAudioRecordingEnabled = niceTeam.niceAudioRecordingEnabled  === true;
            this.niceDesktopAnalyticsEnabled = niceTeam.niceDesktopAnalyticsEnabled === true;
            this.niceQmEnabled = niceTeam.niceQmEnabled || false;
            this.niceScreenRecordingEnabled = niceTeam.niceScreenRecordingEnabled === true;
            this.niceSpeechAnalyticsEnabled = niceTeam.niceSpeechAnalyticsEnabled  === true;
            this.niceWfmEnabled = niceTeam.niceWfmEnabled === true;
            this.niceQualityOptimizationEnabled = niceTeam.niceQualityOptimizationEnabled === true;
            this.niceSurveyCustomerEnabled = niceTeam.niceSurveyCustomerEnabled === true;
            this.nicePerformanceManagementEnabled = niceTeam.nicePerformanceManagementEnabled === true;
            this.niceAnalyticsEnabled = niceTeam.niceAnalyticsEnabled === true;
            this.niceLessonManagementEnabled = niceTeam.niceLessonManagementEnabled === true;
            this.niceCoachingEnabled = niceTeam.niceCoachingEnabled === true;
            this.niceStrategicPlannerEnabled = niceTeam.niceStrategicPlannerEnabled === true;
            this.niceShiftBiddingEnabled = niceTeam.niceShiftBiddingEnabled === true;
            this.niceWfoAdvancedEnabled = niceTeam.niceWfoAdvancedEnabled === true;
            this.niceWfoEssentialsEnabled = niceTeam.niceWfoEssentialsEnabled === true;
            this.agents = niceTeam.agents || null;

        } else {
            this.teamId = 0;
            this.teamName = '';
            this.isActive = true;
            this.description = '';
            this.notes = '';
            this.lastUpdateTime = '';
            this.inViewEnabled = false;
            this.wfoEnabled = false;
            this.wfm2Enabled = false;
            this.qm2Enabled = false;
            this.maxConcurrentChats = 0;
            this.agentCount = 0;
            this.maxEmailAutoParkingLimit = 0;
            this.inViewGamificationEnabled = false;
            this.inViewChatEnabled = false;
            this.inViewLMSEnabled = false;
            this.analyticsEnabled = false;
            this.requestContact = false;
            this.contactAutoFocus = false;
            this.chatThreshold = 0;
            this.emailThreshold = 0;
            this.workItemThreshold = 0;
            this.voiceThreshold = 0;
            this.evolveTeamId = '';
            this.teamLeadUuid = '';
            this.niceAudioRecordingEnabled = false;
            this.niceDesktopAnalyticsEnabled = false;
            this.niceQmEnabled = false;
            this.niceScreenRecordingEnabled = false;
            this.niceSpeechAnalyticsEnabled = false;
            this.niceWfmEnabled = false;
            this.niceQualityOptimizationEnabled = false;
            this.niceSurveyCustomerEnabled = false;
            this.nicePerformanceManagementEnabled = false;
            this.niceAnalyticsEnabled = false;
            this.niceLessonManagementEnabled = false;
            this.niceCoachingEnabled = false;
            this.niceStrategicPlannerEnabled = false;
            this.niceShiftBiddingEnabled = false;
            this.niceWfoAdvancedEnabled = false;
            this.niceWfoEssentialsEnabled = false;
            this.agents = null;
        }
    }
}
